import { render, staticRenderFns } from "./_siteNotesModal.vue?vue&type=template&id=a8c38a9a"
import script from "./_siteNotesModal.vue?vue&type=script&lang=js"
export * from "./_siteNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports